"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module AccuracyLevels
*/

/**
 * Enumeration of available accuracy levels.
 * @alias module:AccuracyLevels
 * @readonly
 * @enum {string}
 */
var AccuracyLevels = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH'
};

var _default = Object.freeze(AccuracyLevels);

exports["default"] = _default;